import { useStaticQuery, graphql } from 'gatsby'

export interface ContentfulMainNavigationPage {
  slug: string
  title: string
}

export interface ContentfulMainNavigationLink {
  id: string
  title: string
  page?: ContentfulMainNavigationPage
  externalUrl?: string
}

export interface UseMenuQuery {
  id: string
  links: ContentfulMainNavigationLink[]
}

export const useHeaderQuery = (): UseMenuQuery | null => {
  const { contentfulMenu } = useStaticQuery(graphql`
    query MainNavigationQuery {
      contentfulMenu(location: { eq: "Header Navigation" }) {
        id
        links {
          id
          title
          externalUrl
          page {
            slug
            title
          }
        }
      }
    }
  `)
  return contentfulMenu ?? null
}
